import { useEffect, useRef } from "react";
import Lenis from "lenis";
import axios from "axios";
import { API } from "@/api";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Artists } from "@/components/landing/Artists";
import { Portfolio } from "@/components/landing/Portfolio";
import { Manifesto } from "@/components/landing/Manifesto";
import { Space } from "@/components/landing/Space";
import { Booking } from "@/components/landing/Booking";
import { LocationSection } from "@/components/landing/Location";
import { Footer } from "@/components/landing/Footer";
import { useLanguage } from "@/i18n";
import { useState } from "react";

export const scrollToId = (id) => {
  if (window.__lenis) window.__lenis.scrollTo(id, { offset: -70, duration: 1.4 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Landing() {
  const [site, setSite] = useState(null);
  const { t } = useLanguage();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.12 });
    window.__lenis = lenis;
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  useEffect(() => {
    axios.get(`${API}/public/site`).then((res) => setSite(res.data)).catch(() => setSite({ settings: {}, artists: [], portfolio: [] }));
  }, []);

  if (!site) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center" data-testid="site-loader">
        <span className="font-mono2 text-xs tracking-[0.3em] uppercase text-zinc-500 animate-pulse">{t("loading")}…</span>
      </div>
    );
  }

  const { settings = {}, artists = [], portfolio = [] } = site;
  const tattoos = portfolio.filter((p) => p.category !== "space");
  const spaces = portfolio.filter((p) => p.category === "space");

  return (
    <div className="bg-[#0A0A0B] text-[#F4F4F6] min-h-screen" data-testid="landing-page">
      <div className="noise-overlay" />
      <Header settings={settings} />
      <Hero settings={settings} heroImage={tattoos[0]?.image} />
      <Marquee settings={settings} />
      <Artists artists={artists} portfolio={tattoos} settings={settings} />
      <Portfolio items={tattoos} artists={artists} />
      <Manifesto settings={settings} />
      <Space spaces={spaces} />
      <Booking settings={settings} />
      <LocationSection settings={settings} />
      <Footer settings={settings} />
    </div>
  );
}
